
import { TranslationSet } from '../types';
import { galleryBasic } from './gallery/basic';
import { galleryUpload } from './gallery/upload';
import { galleryCategories } from './gallery/categories';
import { galleryPdfExport } from './gallery/pdf-export';
import { galleryPhotoManagement } from './gallery/photo-management';

// Combine all gallery translation sets
export const gallery: TranslationSet = {
  ...galleryBasic,
  ...galleryUpload,
  ...galleryCategories,
  ...galleryPdfExport,
  ...galleryPhotoManagement
};
